// extracted by mini-css-extract-plugin
module.exports = {"arrowRight":"ArrowRight_arrowRight__Rh8nE","arrow":"ArrowRight_arrow__p3yp_"};